import { render, staticRenderFns } from "./discuss_area.vue?vue&type=template&id=d7d56e4c&scoped=true"
import script from "./discuss_area.vue?vue&type=script&lang=js"
export * from "./discuss_area.vue?vue&type=script&lang=js"
import style0 from "./discuss_area.vue?vue&type=style&index=0&id=d7d56e4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d56e4c",
  null
  
)

export default component.exports